import { createContext, useContext, useEffect, useState, useCallback } from "react";
import client, { formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [access, setAccess] = useState(null); // null = unknown, obj = access status

  const refreshAccess = useCallback(async () => {
    try {
      const { data } = await client.get("/access/status");
      setAccess(data);
      return data;
    } catch {
      setAccess(null);
      return null;
    }
  }, []);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("sg_token");
      if (!token) {
        setUser(false);
        return;
      }
      try {
        const { data } = await client.get("/auth/me");
        setUser(data.user);
        await refreshAccess();
      } catch {
        localStorage.removeItem("sg_token");
        setUser(false);
      }
    })();
  }, [refreshAccess]);

  const login = async (email, password) => {
    const { data } = await client.post("/auth/login", { email, password });
    localStorage.setItem("sg_token", data.token);
    localStorage.setItem("sg_last_email", email);
    setUser(data.user);
    await refreshAccess();
  };

  const register = async (email, password, name) => {
    const { data } = await client.post("/auth/register", { email, password, name });
    localStorage.setItem("sg_token", data.token);
    localStorage.setItem("sg_last_email", email);
    setUser(data.user);
    await refreshAccess();
  };

  const logout = async () => {
    try { await client.post("/auth/logout"); } catch { /* noop */ }
    localStorage.removeItem("sg_token");
    setUser(false);
    setAccess(null);
  };

  return (
    <AuthContext.Provider value={{ user, access, refreshAccess, login, register, logout, formatApiErrorDetail }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
